@let cart = cartStore.activeCart();
<claas-icon-button
  *hasPermissions="platformManage; disable: true"
  [icon]="{ iconId: '648469', namespace: 'cc', iconStyle: 'bold' }"
  [routerLink]="['parts-shop', 'cart']"
  data-testid="shop-cart-button"
  [iconBadge]="{
    badge: !!cart?.totalItems,
    badgeValue: cart?.totalItems || null,
    badgeVariant: 'info',
    customBadgeClasses: null,
    badgeIcon: null,
    badgeIconSize: 'medium-icon',
    badgeValueLimit: 100,
  }">
</claas-icon-button>
@if (openDrawer()) {
  <div
    class="max-sm:hidden fixed top-14 bottom-0 right-0 z-50 w-[400px] background-paper mat-elevation-z8 flex flex-col"
    (clickOutside)="closeDrawer()"
    data-testid="cart-panel">
    <div class="flex justify-between items-center py-1 px-4">
      <h1 class="th5-title" data-testid="title">
        {{ 'parts_shop.cart.title' | translate: { totalItems: $safeNavigationMigration(cart?.totalItems) } }}
      </h1>
      <claas-icon-button
        [icon]="closeIcon"
        [fontSize]="iconButtonIconFontSize.SMALL"
        (click)="closeDrawer()"
        data-testid="close-button"></claas-icon-button>
    </div>

    @if (cart && cart.totalItems) {
      <div class="overflow-y-auto flex-1">
        <app-parts-shop-responsive-cart-table
          [entries]="cart.entries"
          [scrollToEntry]="cart.lastUpdatedEntry"
          (entryUpdate)="updateEntry($event)"
          (entryRemove)="remove([$event])"
          data-testid="cart-table">
        </app-parts-shop-responsive-cart-table>
      </div>
      <div class="flex flex-col p-4 gap-3 relative" data-testid="mini-cart-footer">
        <div class="footer-shadow"></div>
        <div class="flex flex-col items-end">
          <div class="flex flex-row gap-16 items-end justify-between w-full">
            <div class="mat-body-2 pricing-summary-title" data-testid="pricing-summary-title">
              {{ 'parts_shop.cart.drawer.order_total_label' | translate }}
            </div>
            <div class="pricing-summary-price" data-testid="pricing-summary-price">
              {{ cart.subTotal?.formattedValue ?? '' }}
            </div>
          </div>
          <div class="mat-caption text-secondary" data-testid="order-total-footer-text">
            {{ 'parts_shop.cart.drawer.order_total_footer_text' | translate }}
          </div>
        </div>
        <claas-button [stretch]="true" size="large" (click)="navigateToCart()" data-testid="to-cart-button"
          ><claas-icon
            [iconId]="cartIcon.iconId ?? ''"
            [namespace]="cartIcon.namespace"
            [iconStyle]="cartIcon.iconStyle" />{{
            'parts_shop.cart.drawer.go_to_cart_button_label' | translate
          }}</claas-button
        >
      </div>
    } @else {
      <!-- EMPTY CART -->
      <div class="empty-cart p-6 sm:p-4" data-testid="empty-cart">
        <div class="empty-cart-image-container">
          <img ngSrc="/assets/images/parts-shop/empty_shopping_cart.svg" data-testid="image" alt="" fill />
        </div>
        <div class="flex flex-col items-center">
          <h1 class="empty-cart-title" data-testid="title">{{ 'parts_shop.cart.empty-cart-title' | translate }}</h1>
          <div class="empty-cart-description" data-testid="description">
            {{ 'parts_shop.cart.empty-cart-text' | translate }}
          </div>
        </div>
        <div class="flex flex-row gap-4">
          @if (!smallDisplay()) {
            <claas-button
              buttonClass="secondaryOutline"
              (click)="navigateToCart('fileUpload')"
              data-testid="parts-upload-button"
              >{{ 'parts_shop.cart.file_upload.file-upload-button-label' | translate }}
            </claas-button>
          }
          <claas-button
            (click)="smallDisplay() ? navigateToCart('fastInputDialog') : navigateToCart('fastInput')"
            data-testid="fast-input-button"
            ><claas-icon
              [iconId]="fastInputIcon.iconId ?? ''"
              [namespace]="fastInputIcon.namespace"
              [iconStyle]="fastInputIcon.iconStyle" />{{
              'parts_shop.cart.fast_input.add-button-label' | translate
            }}</claas-button
          >
        </div>
      </div>
    }
  </div>
}
